import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _repeatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/repeat";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
import { v4 as uuidv4 } from "uuid";
export default defineComponent({
  name: "PercentageInput",
  props: {
    name: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Boolean, Number],
      default: ""
    },
    min: {
      type: String,
      default: ""
    },
    max: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    calculated: {
      type: Boolean,
      default: false
    },
    autoCalculated: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    decimals: {
      type: Number,
      default: null
    },
    maxLength: {
      type: Number,
      default: null
    },
    label: {
      type: String,
      default: ""
    },
    hiddenLabel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      labelValue: uuidv4()
    };
  },
  computed: {
    formattedValue() {
      return this.value;
    },
    decimalMask() {
      const maxLength = this.maxLength || "";
      const decimals = this.decimals || "";
      if (decimals == 0) return `9{1,}`;
      if (!decimals) return `9{1,}.{0,1}9{0,}`;
      return `9{1,${maxLength}}.9{1,${decimals}}`;
    },
    decimalPlaceholder() {
      var _context;
      if (!this.decimals) return `0{1,}.{0,1}0{0,}`;
      return `0.${_repeatInstanceProperty(_context = "0").call(_context, this.decimals)}`;
    }
  },
  methods: {
    handleChange({
      target
    }) {
      const value = target.value;
      if (value && value > 100) {
        target.value = 100;
      }
      this.$emit("change", {
        target: _objectSpread(_objectSpread({}, target), {}, {
          value: target.value
        })
      });
    }
  }
});